import { config } from '../../config';
import { fetchWithAuth } from './fetchWithAuth';

const throwResponseError = async (res) => {
    let body = '';
    try {
        body = await res.text();
    } catch {
        body = '';
    }
    const detail = body || res.statusText || `HTTP ${res.status}`;
    throw new Error(`${res.status} ${detail}`);
};

export class RESTproxy {
    constructor(resource) {
        this.resource = resource;
    }

    async get(id) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/${this.resource}/${id}`);
        if (!res.ok) await throwResponseError(res);
        return res.json();
    }

    async list() {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/${this.resource}`);
        if (!res.ok) await throwResponseError(res);
        return res.json();
    }

    async create(data) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/${this.resource}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
        });
        if (!res.ok) await throwResponseError(res);
        return res.text();
    }

    async update(data) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/${this.resource}/${data.id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
        });
        if (!res.ok) await throwResponseError(res);
    }
}
